import { Component, computed, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '@core/services/language.service';

const DISMISS_KEY = 'banner_claude_integration_dismissed';
const CTA_URL = 'https://www.ezatwork.com/integrations/claude/?utm_source=app_banner&utm_medium=in_app&utm_campaign=claude_integration';

@Component({
  selector: 'app-announcement-banner',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, TranslateModule],
  templateUrl: './announcement-banner.component.html',
  styleUrls: ['./announcement-banner.component.scss'],
})
export class AnnouncementBannerComponent {
  private readonly langSvc = inject(LanguageService);

  private readonly dismissed = signal(!!localStorage.getItem(DISMISS_KEY));

  readonly show = computed(() => !this.dismissed());
  readonly isRtl = computed(() => this.langSvc.isRTL());

  readonly ctaUrl = CTA_URL;

  dismiss(): void {
    localStorage.setItem(DISMISS_KEY, '1');
    this.dismissed.set(true);
  }

  onCtaClick(): void {
    const gtag = (window as any).gtag;
    if (typeof gtag === 'function') {
      gtag('event', 'banner_claude_click');
    }
  }
}
